import { Injectable, Input } from '@angular/core';
import { IDashboardSection } from '../dashboard.component';

@Injectable()
export abstract class BaseDashboardInfoComponent {
  @Input() public loading:boolean;
  @Input() public section:IDashboardSection;
}